import { Service } from '../mainService'
import { FiltrosPrazoDeVencimento } from '@/types/administracao/filtros-prazo-de-vencimento'
import { PrazoDeVencimento } from '@/types/administracao/prazo-de-vencimento';
import { PrazoDeVencimentoLRFCI } from '@/types/administracao/prazos-lrfci/prazo-de-vencimento-lrfci';
import { FiltrosPrazoDeVencimentoLRFCI } from '@/types/administracao/prazos-lrfci/filtros-prazo-de-vencimento-lrfci';

const prazosService = {
    //prazos vcto
    buscarPrazosVencimento,
    getPrazoVencimento,
    criarPrazoVencimento,
    editarPrazoVencimento,
    removerPrazoVencimento,
    getCombos,
    //prazos vcto lrfci
    buscarPrazosVencimentoLRFCI,
    getPrazoVencimentoLRFCI,
    criarPrazoVencimentoLRFCI,
    editarPrazoVencimentoLRFCI,
    removerPrazoVencimentoLRFCI,
    getCombosLRFCI,
    buscarTiposProrrogacao
}

async function buscarPrazosVencimento(filtros: FiltrosPrazoDeVencimento) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/vencimento/consultarVencimentos", filtros.toFormData());
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarTiposProrrogacao() {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/prorrogacao/tiposProrrogacao"); //VUE_APP_PRAZOS_PRORROGACAO
        return response;
    } catch (e: any) {
        return e.response;
    }
}


async function getPrazoVencimento(id: string) {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + `/vencimento/prazoVencimentoById/${id}`);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

/**
 * @returns os três combos que são utilizados nas páginas de prazos de vencimento.
 * @since 20220609
 */
async function getCombos() {
    try {
        const refs = await Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimento/referencias");
        const exs = await Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimento/exercicios");
        const esfs = await Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimento/esferas");
        return {
            referencias: refs.data,
            exercicios: exs.data,
            esferas: esfs.data
        };
    } catch (e: any) {
        return e.response;
    }
}

async function criarPrazoVencimentoLRFCI(prazo: PrazoDeVencimentoLRFCI) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_USERS_API + "/vencimentoLRF/adicionarVencimentoLRF", prazo.toFormData());
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function editarPrazoVencimentoLRFCI(prazo: PrazoDeVencimentoLRFCI) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_USERS_API + "/vencimentoLRF/alterarVencimentoLRF", prazo.toFormData());
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function removerPrazoVencimentoLRFCI(id: number) {
    try {
        const response = await Service.$http.delete(process.env.VUE_APP_USERS_API + `/vencimentoLRF/excluirVencimentoLRF/${id}`);
        return response;
    }
    catch (e: any) {
        console.error('erro ao remover prazo de LRFCI', e)
        return e.response;
    }
}

async function buscarPrazosVencimentoLRFCI(filtros: FiltrosPrazoDeVencimentoLRFCI) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/vencimentoLRF/consultarVencimentosLRF", filtros.toFormData());
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function getPrazoVencimentoLRFCI(id: string) {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + `/vencimentoLRF/prazoVencimentoLRFById/${id}`);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

/**
 * Add
 * @param prazo PrazoDeVencimento
 * @returns prazoDeVencimento prazo
 * @since 20220609
 */
async function criarPrazoVencimento(prazo: PrazoDeVencimento) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_USERS_API + "/vencimento/adicionarVencimento", prazo.toFormData());
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

/**
 * Edit
 * @param prazo PrazoDeVencimento
 * @returns prazoDeVencimento prazo
 * @since 20220610
 */
async function editarPrazoVencimento(prazo: PrazoDeVencimento) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_USERS_API + "/vencimento/alterarVencimento", prazo.toFormData());
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

/**
 * Remove um prazo de vencimento
 * @param id number
 * @since 20220609
 */
async function removerPrazoVencimento(id: number) {
    try {
        const response = await Service.$http.delete(process.env.VUE_APP_USERS_API + `/vencimento/excluirVencimento/${id}`);
        return response;
    }
    catch (e: any) {
        console.error('erro ao remover prazo de vencimento', e)
        return e.response;
    }
}

/**
 * @returns os três combos que são utilizados nas páginas de prazos de vencimento LRFCI.
 * @since 20220614
 */
async function getCombosLRFCI() {
    try {

        const [rExercicios, rPeriodosLRF, rPeriodosPrestacao, rTiposRelatorioLRF] = await Promise.all([
            Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimento/exercicios"),
            Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimentoLRF/periodosLRF"),
            Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimentoLRF/periodosPrestacaoLRF"),
            Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimentoLRF/tiposRelatorioLRF"),
        ])

        return {
            exercicios: rExercicios.data,
            periodosRelatorio: rPeriodosLRF.data,
            periodosPrestacao: rPeriodosPrestacao.data,
            tiposRelatorio: rTiposRelatorioLRF.data
        };
    } catch (e: any) {
        return e.response;
    }
}

export default prazosService;